import React from 'react';
import { motion } from 'framer-motion';
import { ScrollText, MapPin, ArrowUpRight } from 'lucide-react';
const NORMS = [{
  code: 'Decreto 462 de 2025',
  description: 'Marco normativo con enfoque intercultural que reconoce el papel de las autoridades e instituciones indígenas en la gestión catastral.',
  href: 'https://www.funcionpublica.gov.co/eva/gestornormativo/norma.php?i=259716'
}, {
  code: 'Resolución 716 de 2025',
  description: 'Lineamientos para fortalecer y coordinar el Sistema de Información Geográfica Indígena (SIG-Indígena) de la Comisión Nacional de Territorios Indígenas.',
  href: 'https://www.alcaldiabogota.gov.co/sisjur/normas/Norma1.jsp?dt=S&i=181050'
}, {
  code: 'Resolución 806 de 2025',
  description: 'Requisitos para la contratación de Operadores Catastrales Indígenas.',
  href: 'https://www.igac.gov.co/transparencia-y-acceso-a-la-informacion-publica/normograma/resolucion-806-de-2025'
}, {
  code: 'Resolución 807 de 2025 (IGAC)',
  description: 'Permite adaptar los procesos catastrales a las particularidades de los territorios indígenas.',
  href: 'https://www.igac.gov.co/transparencia-y-acceso-a-la-informacion-publica/normograma/resolucion-807-de-2025'
}];
const RESGUARDOS = [{
  name: 'Solano',
  dept: 'Caquetá'
}, {
  name: 'Puerto Leguízamo',
  dept: 'Putumayo'
}];
export function CatastroMultiproposito() {
  return <section id="catastro" className="py-24 md:py-32 px-4 md:px-8 bg-bone-dark scroll-mt-24" data-id="element-76" data-mp="2p2f6fr5t797l">
      <div className="max-w-[1400px] mx-auto" data-id="element-77" data-mp="2k3luw4a31sa2">
        {/* Header */}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 mb-16 lg:mb-20" data-id="element-78" data-mp="2yxqnwh8lquj1">
          <div className="lg:col-span-6" data-id="element-79" data-mp="2u0qfhzoa5for">
            <span className="block text-clay uppercase tracking-[0.2em] text-xs font-semibold mb-5" data-id="element-80" data-mp="2txko2ds6i1pv">
              Avance 02 · Catastro Multipropósito
            </span>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif text-forest leading-[1.08]" data-id="element-81" data-mp="zmz1yp2tybo1">
              Operación catastral multipropósito en territorios colectivos:
              continúan los avances para fortalecer las capacidades y usabilidad
              de la información por parte de los pueblos indígenas
            </h2>
          </div>
          <div className="lg:col-span-6 lg:pt-3" data-id="element-82" data-mp="239udeyw1xlol">
            <h3 className="font-serif text-2xl md:text-3xl text-forest mb-5 leading-tight" data-id="element-83" data-mp="23am4pxim8x92">
              Un catastro construido desde el diálogo intercultural
            </h3>
            <div className="space-y-5 text-charcoal/80 font-light leading-relaxed" data-id="element-84" data-mp="2c8odiz8lcu6w">
              <p className="text-lg md:text-xl text-charcoal/85" data-id="element-85" data-mp="2h1qywk37sxc0">
                Colombia sigue avanzando en la implementación del Catastro
                Multipropósito en territorios indígenas, una herramienta clave
                para el reconocimiento, la protección y la gestión integral de
                los territorios ancestrales.
              </p>
              <p data-id="element-86" data-mp="kan01g785r56">
                El Catastro Multipropósito viene ganando importancia al
                proporcionar insumos cartográficos y catastrales que fortalecen
                la gobernanza territorial, el ejercicio de la autonomía y la
                toma de decisiones por parte de los pueblos indígenas, quienes
                han logrado transformar la Consulta Previa para la Política
                Pública de Catastro Multipropósito en Territorios y
                Territorialidades Indígenas en una oportunidad para el
                reconocimiento territorial, una mayor gobernanza y el
                fortalecimiento de sus capacidades de gestión.
              </p>
            </div>
          </div>
        </div>

        {/* Mapa — Resguardos indígenas en municipios TEFOS */}
        <motion.figure initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-50px'
      }} className="bg-bone border border-charcoal/10 p-6 md:p-10 mb-12 lg:mb-16" data-id="element-87" data-mp="1lrm5ifwhv7q9">
          <h3 className="font-serif text-2xl md:text-3xl text-forest leading-tight mb-6" data-id="element-88" data-mp="16ja9wk4m7gr5">
            Resguardos indígenas en los municipios TEFOS
          </h3>
          <div className="w-full max-w-3xl mx-auto" data-id="element-89" data-mp="wizwayeo47bg">
            <img src="https://cdn.magicpatterns.com/uploads/iASjZjCC6LDEpEifumcJk9/resguardos_conSanAndres.png" alt="Mapa de Colombia, incluido el archipiélago de San Andrés y Providencia, con los resguardos indígenas resaltados en los municipios del Proyecto TEFOS" className="w-full h-auto" data-id="element-90" data-mp="wlvvsr65z420" />
          </div>
          <figcaption className="text-charcoal/55 text-xs font-light leading-relaxed mt-6 max-w-3xl" data-id="element-91" data-mp="1fhcfze37gzla">
            Fuente: Mapa no oficial, elaborado con base en información de 2025
            tomada de la ANT.
          </figcaption>
        </motion.figure>

        {/* Avances normativos — forest panel */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-50px'
      }} className="bg-forest text-bone p-8 md:p-12 lg:p-14 mb-12 lg:mb-16" data-id="element-92" data-mp="3snsk9ujo2gnc">
          <div className="flex items-center gap-4 mb-6" data-id="element-93" data-mp="39q97cfu38dvn">
            <div className="w-12 h-12 bg-clay flex items-center justify-center text-bone flex-none" data-id="element-94" data-mp="39qrdq5ags8ha">
              <ScrollText size={22} data-id="element-95" data-mp="34t95kh49txac" />
            </div>
            <span className="text-clay-light text-xs uppercase tracking-[0.2em] font-semibold" data-id="element-96" data-mp="3irfs513rsaup">
              2025–2026 · Marco normativo
            </span>
          </div>
          <h3 className="font-serif text-2xl md:text-3xl lg:text-4xl leading-tight mb-6 max-w-3xl" data-id="element-97" data-mp="y0ylzpgi5dhj">
            Avances normativos para una gestión catastral intercultural
          </h3>
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 mb-10" data-id="element-98" data-mp="u1pnk7aiorfn">
            <p className="text-bone/85 font-light leading-relaxed" data-id="element-99" data-mp="3mvy0tjimm31o">
              Tras la protocolización de la consulta previa en 2023 y la
              expedición del Decreto 462 de 2025, el país cuenta con un marco
              normativo que incorpora un enfoque intercultural y reconoce el
              papel de las autoridades e instituciones indígenas en la gestión
              catastral, sumado a la adopción de instrumentos técnicos
              específicos.
            </p>
            <p className="text-bone/75 font-light leading-relaxed text-sm md:text-base" data-id="element-100" data-mp="392ouxstvzznw">
              Esta consolidación normativa responde a una visión que busca
              articular los insumos cartográficos y catastrales con los
              conocimientos propios de los pueblos indígenas sobre sus
              territorios. El proceso abre nuevas oportunidades para fortalecer
              su papel como autoridades ambientales y territoriales, al tiempo
              que reconoce sus saberes y formas de representación del espacio
              como aportes fundamentales para la construcción del derecho y para
              enriquecer la comprensión de la geografía del país.
            </p>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-px bg-bone/15" data-id="element-101" data-mp="28w39wkgrddkb">
            {NORMS.map(norm => <a key={norm.code} href={norm.href} target="_blank" rel="noopener noreferrer" className="group bg-forest p-6 hover:bg-forest-light transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-clay-light" data-id="element-102" data-mp="1yvsviwizm03k">
                <div className="flex items-start justify-between gap-3 mb-2" data-id="element-103" data-mp="1l5pgapiiz6nm">
                  <div className="font-serif text-clay-light text-lg md:text-xl" data-id="element-104" data-mp="1g64gydzg0wad">
                    {norm.code}
                  </div>
                  <ArrowUpRight size={18} className="text-clay-light flex-none mt-1 transform transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" data-id="element-105" data-mp="1b708jpkcf2l3" />
                </div>
                <p className="text-bone/70 text-sm font-light leading-relaxed" data-id="element-106" data-mp="2q2rq5687nkmj">
                  {norm.description}
                </p>
              </a>)}
          </div>
        </motion.div>

        {/* Acciones en territorio */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-50px'
      }} className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-12" data-id="element-107" data-mp="2gb58os5a4pbc">
          <div className="lg:col-span-7" data-id="element-108" data-mp="1xdudpjqoki1p">
            <span className="block text-clay uppercase tracking-[0.2em] text-xs font-semibold mb-4" data-id="element-109" data-mp="1xf5dz9kx37o2">
              Acciones en territorio
            </span>
            <p className="text-charcoal/85 font-light leading-relaxed text-lg md:text-xl" data-id="element-110" data-mp="1iqvlhmk01jlx">
              Mientras continúan los ajustes institucionales y normativos,
              también avanzan las acciones en territorio. Gracias a un
              procedimiento especial definido entre el IGAC y la Agencia
              Nacional de Tierras (ANT), se actualizaron los resguardos
              indígenas de los municipios de Solano, en Caquetá, y Puerto
              Leguízamo, en Putumayo (ver mapa).
            </p>
          </div>
          <div className="lg:col-span-5" data-id="element-111" data-mp="1wpv6mk8azgdc">
            <div className="text-xs uppercase tracking-[0.2em] text-charcoal/60 font-semibold mb-4" data-id="element-112" data-mp="1wp2aseavub9z">
              Resguardos actualizados
            </div>
            <div className="space-y-3" data-id="element-113" data-mp="26i105ye7e5un">
              {RESGUARDOS.map(r => <div key={r.name} className="flex items-center gap-4 bg-bone border border-charcoal/10 px-5 py-4" data-id="element-114" data-mp="2kfpmlanx5l1t">
                  <MapPin className="text-clay flex-none" size={22} strokeWidth={1.5} data-id="element-115" data-mp="2srp5f420k00w" />
                  <div data-id="element-116" data-mp="2nznylxnm71i9">
                    <div className="text-forest font-serif text-xl leading-tight" data-id="element-117" data-mp="2nz5sm9b5h8x5">
                      {r.name}
                    </div>
                    <div className="text-charcoal/55 text-sm font-light" data-id="element-118" data-mp="2e3kni2asbsj6">
                      {r.dept}
                    </div>
                  </div>
                </div>)}
            </div>
          </div>
        </motion.div>

        {/* Mapas — comunidades étnicas y área incorporada */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-50px'
      }} className="grid grid-cols-1 lg:grid-cols-2 gap-6 mt-12 lg:mt-16" data-id="element-119" data-mp="31rcaq0xv5pz8">
          <figure className="bg-bone border border-charcoal/10 p-5 md:p-6 flex flex-col" data-id="element-120" data-mp="1mdzmzpw8k3ym">
            <img src="https://cdn.magicpatterns.com/uploads/rjSA9CWYDV16CJeS4KzJ9a/comunidadesetnicas.png" alt="Mapa de resguardos indígenas con el porcentaje de incorporación por área" className="w-full h-auto" data-id="element-121" data-mp="1rhv3p715h7v" />
            <figcaption className="text-charcoal/55 text-xs font-light leading-relaxed mt-4" data-id="element-122" data-mp="flr4s5ajnzgs">
              Fuente: Mapa no oficial, elaborado con base en información de 2025
            </figcaption>
          </figure>
          <figure className="bg-bone border border-charcoal/10 p-5 md:p-6 flex flex-col" data-id="element-123" data-mp="phc6017sgvph">
            <img src="https://cdn.magicpatterns.com/uploads/3koTGn7xhjKQmDvreMsXtp/comunidadesetnicas_barras_corregido.png" alt="Gráfico de barras del área incorporada en hectáreas por resguardo indígena" className="w-full h-auto" data-id="element-124" data-mp="tla6ogcriekn" />
            <figcaption className="text-charcoal/55 text-xs font-light leading-relaxed mt-4" data-id="element-125" data-mp="30bztdbqqv3cf">
              Fuente: Mapa no oficial, elaborado con base en información de 2025
            </figcaption>
          </figure>
        </motion.div>
      </div>
    </section>;
}